<script>
  import authService from "../../services/authService";
  import {
    setUserLoggedIn,
    setUser,
    letters,
    userLoggedIn,
    setLoadingData,
    user,
  } from "../../services/store";
  import { checkJwtToken } from "../../services/JwtHelper";
  import { getAllData } from "../../services/letterService";
  import { location, replace } from "svelte-spa-router";
  import Icon from "fa-svelte";
  import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
  import { faEyeSlash } from "@fortawesome/free-solid-svg-icons/faEyeSlash";
  import { showToast } from "../../helper/Toast";
  import { RingLoader } from "svelte-loading-spinners";
  import { _ } from "svelte-i18n";
  import { beforeUpdate, tick } from "svelte";

  let school, pw, loading, loginIn;

  beforeUpdate(() => {
    let tokenUser = checkJwtToken();
    if ($userLoggedIn && $user && tokenUser && !loginIn) {
      replace("/");
    }
  });

  async function onLogin() {
    if (school && pw) {
      loading = true;
      loginIn = true;
      const response = await authService.login({
        name: school.toLowerCase(),
        password: pw,
      });
      if (response) {
        if (response.accessToken) {
          setUserLoggedIn(true);
          showToast($_("login.m_login_success"), "SUCCESS");
          checkJwtToken();
          setLoadingData(true);
          await getAllData();
          setLoadingData(false);
          loading = false;
          if ($letters && $letters.length) {
            replace("/letters/a");
            setTimeout(function () {
              showToast($_("login.m_data_success"), "SUCCESS");
              loginIn = false;
            }, 500);
          } else {
            showToast($_("login.m_data_error"), "ERROR");
            loginIn = false;
          }
        } else {
          loading = false;
          loginIn = false;
          showToast($_("login.m_login_error"), "ERROR");
        }
      } else {
        loading = false;
        loginIn = false;
        showToast($_("server.no_response"), "ERROR");
      }
    }
  }
  let icon = faEye;
  let pwType = "password";
  let pwHiddenButtonDescription = $_("login.show_pw");
  let showPw = false;
  function showPassword(e) {
    e.preventDefault();
    if(!e.charCode || (e && e.charCode === 13)){
    showPw = !showPw;
    pwType = showPw ? "text" : "password";
    pwHiddenButtonDescription = showPw
      ? $_("login.hide_pw")
      : $_("login.show_pw");
    icon = showPw ? faEyeSlash : faEye;

    let input = document.getElementById("current-password");
    input.setAttribute("type", pwType);
    }
  }
  function onSchoolPress(e) {
    if (e.charCode === 13) document.getElementById("current-password").focus();
  }
  function onPwPress(e) {
    if (e.charCode === 13) onLogin();
  }
  function onFormKey(e) {
    if (e.charCode === 13) e.preventDefault();
    return;
  }
</script>
<form on:keypress={onFormKey}>
<div class="container mx-auto py-8 h-half">
  <h1 class="text-3xl pb-4 text-gray-600 text-center">{$_('login.welcome')}</h1>
  <div class="flex content-center items-center justify-center h-full">
    <div class="w-full lg:w-4/12 px-4">
      <div
        class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg  border-0 glass">
        <div class="rounded-t mb-0 px-6 py-6">
          <div class="text-center mb-3">
            <h6 class="text-gray-600 font-bold">{$_('login.title')}</h6>
          </div>
          <hr class="mt-6 border-b-1 border-gray-400" />
        </div>
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="username">
              {$_('login.school_fld')}
            </label>
            <input
              bind:value={school}
              on:keypress={onSchoolPress}
              id="username"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm border-2 outline-none focus:border-accent-300  w-full ease-linear transition-all duration-150"
              placeholder={$_('login.school_place')} />
              <span class="focus-border"></span>
              <i></i>
          </div>

          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="current-password">
              {$_('login.pw_fld')}
            </label>
            <input
              bind:value={pw}
              id="current-password"
              type="password"
              autocomplete="on"
              on:keypress={onPwPress}
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm border-2 outline-none focus:border-accent-300  w-full ease-linear transition-all duration-150"
              placeholder={$_('login.pw_place')} />
            <button on:click={showPassword}
             on:keypress={showPassword}>
              <Icon {icon} />
              {pwHiddenButtonDescription}
            </button>
          </div>

          <div class="text-center mt-6">
            <button
              disabled={!pw || !school || loading}
              on:click={onLogin}
              on:keypress={onLogin}
              class="py-2 px-4 bg-primary-100 text-white font-semibold rounded-lg shadow-md w-full 
              ease-linear transition-all duration-150
               hover:bg-primary-200 focus:outline-none disabled:opacity-50"
              type="submit">
              {#if loading}
                <div class="absolute">
                  <RingLoader size="30" color="#DB2777" unit="px" />
                </div>
              {/if}
              {$_('login.button')}
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="flex flex-wrap mt-6 relative">
        <div class="w-1/2">
          <a class="text-gray-300"> <small>Forgot password?</small> </a>
        </div>
        <div class="w-1/2 text-right">
          <a class="text-gray-300"> <small>Create new account</small> </a>
        </div>
      </div> -->
    </div>
  </div>
</div>
</form>